import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import ReactToPrint from "react-to-print";
import {
  getAllChartofaccounts,
  getSpecificChartofaccounts,
} from "../../../actions/chartofaccountsAction";
import { getJournalSearchResult } from "../../../actions/journalAction";
import moment from "moment";
import { Link } from "react-router-dom";


import {
  Layout,
  Breadcrumb,
  Row,
  Col,
  DatePicker,
  TimePicker,
  Space,
  Select,
  Divider,
  Skeleton,
  Card,
  Button,
  AutoComplete,
  Input,
  Spin,
  Drawer,
} from "antd";
const { Content } = Layout;
const { RangePicker } = DatePicker;
const { Option } = Select;
const { Search } = Input;

const AdcanceQuickview = ({
  start,
  end,
  details,
  location,
  getJournalSearchResult,
}) => {
  const componentRef = useRef();
  const [visible, setVisible] = useState(false);
  const [charts, setcharts] = useState([]);
  const [journals, setjournals] = useState([]);
  const totaldebit = useRef(0);
  const totalcredit = useRef(0);
  const balance = useRef(0);
  const spinning = useRef(false);
  var formatter = new Intl.NumberFormat("en-IN");

  const showDrawer = () => {
    totaldebit.current = 0;
    totalcredit.current = 0;
    balance.current = details.previous_amount;
    getJournalSearchResult(
      "",
      start.current,
      end.current,
      "",
      details.account_code,
      "", "", "",
      // location.current == "-99" ? "" : location.current
    ).then((result) => {
      spinning.current = false;
      result.reverse();
      setjournals(result);
      setVisible(true)
    });

  }

  const onClose = () => {
    setVisible(false);
  };



  const Rendercontent = () => {
    totaldebit.current = 0;
    totalcredit.current = 0;
    balance.current = details.previous_amount;
    return (
      <>
        <Row>
          <Col
            span={24}
            style={{
              padding: "1rem",
              border: "1px solid whitesmoke",
              width: "100%",
            }}
          >
            <Spin spinning={spinning.current} style={{ width: "100%" }}>
              <div ref={componentRef} style={{ padding: "10px" }}>
                <table className="account_table">
                  <tr
                    style={{
                      textAlign: "center",
                      height: "50px",
                      backgroundColor: "#99fe8e"
                    }}
                  >
                    <td>
                      <b>Particulars</b>
                    </td>
                    <td>
                      <b>Debit</b>
                    </td>
                    <td>
                      <b>Credit</b>
                    </td>
                    {/* <td>
                      <b>Balance</b>
                    </td> */}
                  </tr>
                  <tr>
                    <td style={{ textAlign: "center" }}><b>Opening Balance</b></td>
                    <td style={{ textAlign: "right" }}>{details.previous_status == "Debit" ? formatter.format(
                      parseFloat(Math.abs(balance.current)).toFixed(2)
                    ) : null}</td>
                    <td style={{ textAlign: "right" }}>{details.previous_status == "Credit" ? formatter.format(
                      parseFloat(Math.abs(balance.current)).toFixed(2)
                    ) : null}</td>
                    {/* <td style={{ textAlign: "right" }}>{formatter.format(
                      parseFloat(Math.abs(balance.current)).toFixed(2)
                    )}</td> */}
                  </tr>
                  {journals.map(journal => {
                    if (journal.type == "Debit") {
                      if (journal.increase)
                        totaldebit.current += parseFloat(journal.amount);
                      else totaldebit.current -= parseFloat(journal.amount);
                    }
                    else {
                      if (journal.increase)
                        totalcredit.current += parseFloat(journal.amount)
                      else totalcredit.current -= parseFloat(journal.amount)
                    }

                    if (journal.increase)
                      balance.current += parseFloat(journal.amount)
                    else balance.current -= parseFloat(journal.amount)

                    return <tr>
                      <td style={{ textAlign: "center" }}>{journal.details}</td>
                      <td style={{ textAlign: "right" }}>{journal.type == "Debit" ? formatter.format(
                        parseFloat(Math.abs(journal.amount)).toFixed(2)
                      ) : null}</td>
                      <td style={{ textAlign: "right" }}>{journal.type == "Credit" ? formatter.format(
                        parseFloat(Math.abs(journal.amount)).toFixed(2)
                      ) : null}</td>
                      {/* <td style={{ textAlign: "right" }}>{formatter.format(
                        parseFloat(Math.abs(balance.current)).toFixed(2)
                      )}</td> */}
                    </tr>
                  })}
                  <tr style={{ backgroundColor: "#d9fcd5ff" }}>
                    <td style={{ textAlign: "center" }}>Sub total</td>
                    <td style={{ textAlign: "right" }}>{formatter.format(
                      parseFloat(Math.abs(totaldebit.current)).toFixed(2)
                    )}</td>
                    <td style={{ textAlign: "right" }}>{formatter.format(
                      parseFloat(Math.abs(totalcredit.current)).toFixed(2)
                    )}
                    </td>
                    {/* <td style={{ textAlign: "right" }}>{formatter.format(
                      parseFloat(Math.abs(balance.current)).toFixed(2)
                    )}</td> */}
                  </tr>
                  <tr>
                    <td style={{ textAlign: "center" }}><b>Closing Balance</b></td>
                    <td style={{ textAlign: "right" }}>{details.status == "Debit" ? formatter.format(
                      parseFloat(Math.abs(details.amount)).toFixed(2)
                    ) : null}</td>
                    <td style={{ textAlign: "right" }}>{details.status == "Credit" ? formatter.format(
                      parseFloat(Math.abs(details.amount)).toFixed(2)
                    ) : null}</td>
                    {/* <td style={{ textAlign: "right" }}>{formatter.format(
                      parseFloat(Math.abs(balance.current)).toFixed(2)
                    )}</td> */}
                  </tr>

                </table>

              </div>
            </Spin>
          </Col>
        </Row>
      </>
    );

  };
  return (
    <>
      <Link to="#" style={{ color: "black" }} onClick={showDrawer} key={details.id}>
        {details.account_name}
      </Link>
      <Drawer
        width="50%"
        title={details.account_name}
        placement="right"
        closable={true}
        onClose={onClose}
        visible={visible}
      >
        {Rendercontent()}
      </Drawer>

    </>
  );
};

export default connect(null, {
  getJournalSearchResult,
})(AdcanceQuickview);
